import { render } from "./MobileShell.vue?vue&type=template&id=5daa03a5"
import script from "./MobileShell.vue?vue&type=script&lang=js"
export * from "./MobileShell.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__